import api from "../../api/_medicament";

const state = () => ({
    medicaments: [],
    categories: [],
    medicament: {},
});

// getters
const getters = {
    medicaments: (state) => {
        return state.medicaments;
    },

    medicament: (state) => {
        return state.medicament;
    },

    categories: (state) => {
        return state.categories;
    },
};

// mutations
const mutations = {
    SET_MEDICAMENTS(state, medicaments) {
        state.medicaments = medicaments;
    },

    SET_CATEGORIES(state, categories) {
        state.categories = categories;
    },
    SET_MEDICAMENT(state, medicament) {
        state.medicament = medicament;
    },
};

// actions
const actions = {
    /**
     * Liste des articles
     */
    getMedicamentCategories({ commit }) {
        api.categorie().then((response) => {
            commit("SET_CATEGORIES", response);
        });
    },

    /**
     * Liste des articles
     */
    getMedicaments({ commit }) {
        api.medicaments().then((response) => {
            commit("SET_MEDICAMENTS", response);
        });
    },

    /**
     * Importe une liste de médicament
     * @param {*} param0
     * @param {*} param1
     * @returns
     */
    importMedicament({ dispatch }, { data }) {
        return new Promise((resolve, reject) => {
            api.importMedicament(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    importConsommable({ dispatch }, { data }) {
        return new Promise((resolve, reject) => {
            api.importConsommable(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    deleteMedicament({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteMedicament(data).then(
                (response) => {
                    resolve(response);
                    dispatch("getMedicaments");
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
